var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFieldVisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.620312 10.5L5.02591 4.5H15.9741L20.3797 10.5L15.9741 16.5H5.02591L0.620312 10.5Z",
    stroke: "#FAE232"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 3,
    fill: "#FAE232",
    fillOpacity: 0.2,
    stroke: "#FAE232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldVisible);
export default __webpack_public_path__ + "static/media/field_visible.3896094365c115b5f1fbafd5b26e57a2.svg";
export { ForwardRef as ReactComponent };